import React, { useEffect, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import testImage from '../assets/img/exam/scholor1.png'


const testimonials = [
  {
    name: 'Anthony Nicoll',
    role: 'Student',
    image: {testImage},
    quote:
      'There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.',
  },
  {
    name: 'Richard Lock',
    role: 'Student',
    image: {testImage},
    quote:
      'There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.',
  },
  {
    name: 'Randal Grand',
    role: 'Student',
    image: {testImage},
    quote:
      'There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.',
  },
  {
    name: 'Edward Miles',
    role: 'Student',
    image: {testImage},
    quote:
      'There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.',
  },
  {
    name: 'Ninal Gordon',
    role: 'Student',
    image: {testImage},
    quote:
      'There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.',
  },
];

const options = {
  loop: true,
  margin: 20,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 3 },
  },
};

const TestimonialSlider = () => {
   const [testSeriesData1, settestSeriesData1] = useState([]);
    const [loading, setLoading] = useState(true);  // Handle loading state
  
    const fetchWallOfFame = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getWhatOurStudentsSay`);
      
        settestSeriesData1(response.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchWallOfFame();
    }, []); 
  return (
    <div className="row">
      <OwlCarousel className="testimonial-slider owl-theme" {...options}>
        {testSeriesData1.map((testimonial, index) => (
          <div className="testimonial-item" key={index}>
            <div className="testimonial-rate">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="fas fa-star"></i>
              ))}
            </div>
            <div className="testimonial-quote">
              <p>{testimonial.feedback}</p>
            </div>
            <div className="testimonial-content">
              <div className="testimonial-author-img">
               <img src={`${Image_Base_Url}${testimonial.media_image_path}`} alt="media_image_path" />
              </div>
              <div className="testimonial-author-info">
                <h4>{testimonial.student_name}</h4>
                {/* <p>{testimonial.role}</p> */}
              </div>
            </div>
            <span className="testimonial-quote-icon">
              <i className="far fa-quote-right"></i>
            </span>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
};

export default TestimonialSlider;
